import { BaseComponentProps, BaseField } from "./baseComponentProps";
import React from "react";
export class ProgressBar extends React.Component<ProgressBarProps, any> {
    private _progressBar: kendo.ui.ProgressBar;
    private _progressBarRef: any;
    private _id = null;
    private _value: any;

    constructor(props) {
        super(props);
        this._id = kendo.guid();
    }
    componentWillUnmount() {
        this._progressBar.destroy();
    }
    componentDidMount() {
        this._value = this.props.value;
        this._progressBar = $(this._progressBarRef).kendoProgressBar({
            value: this.props.value,
            enable: false,
            min: this.props.field.min,
            max: this.props.field.max,
            showStatus: true,
            type: this.props.field.progressType,
            change: (ev) => {
                this._value = ev.value;
                this.props.onChange(this.props.field, this._value, null);
            },
            animation: {
                duration: 100
            }

        }).data("kendoProgressBar");

    }
    componentDidUpdate(prevProps, prevState) {
        this._value = this.props.value;
        this._progressBar.value(this._value);
    }
    render() {
        return (
            <>
                <div style={{ width: '100%' }} ref={(r) => this._progressBarRef = r}> </div>
            </>
        );
    }
}
export interface ProgressBarProps extends BaseComponentProps {
    field: ProgressBarField;
    value: number;
}

export interface ProgressBarField extends BaseField {
    min: number;
    max: number;
    progressType: string;
}